import React, { useState } from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
import { Link } from 'react-router-dom'
import { useFormik } from 'formik'
import { apiRequestPassword } from '../redux/AuthCRUD'
import { useIntl } from 'react-intl'


export function ForgotPassword() {
  const intl = useIntl()

  const initialValues = {
    email: '',
  }

  const forgotPasswordSchema = Yup.object().shape({
    email: Yup.string().email(intl.formatMessage({ id: 'AUTH.VALIDATION.INVALID' }, { name: 'Email' }))
      .required(intl.formatMessage({ id: 'AUTH.VALIDATION.REQUIRED' }, { name: 'Email' })),
  })

  const [loading, setLoading] = useState(false)
  const [hasErrors, setHasErrors] = useState<boolean | undefined>(undefined)
  const [responseString, setResponseString] = useState<null | any>(null)

  const formik = useFormik({
    initialValues,
    validationSchema: forgotPasswordSchema,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      setLoading(true)
      setHasErrors(undefined)
      apiRequestPassword(values.email)
        .then((data: any) => {
          setSubmitting(false)
          if (data.data.status === 200) {
            setHasErrors(false)
            setLoading(false)
            setResponseString(data.data.response ? data.data.response : intl.formatMessage({ id: 'TOAST.IF_THERE_IS_A_USER_WITH_A_MATCHING_E-MAIL_ADDRESS_A_PASSWORD_RESET_E-MAIL_WAS_SENT' }))
          } else {
            setHasErrors(true)
            setLoading(false)
            setResponseString(data.data.message)
          }
        })
        .catch(() => {
          setHasErrors(true)
          setLoading(false)
          setSubmitting(false)
          setStatus(intl.formatMessage({ id: 'AUTH.VALIDATION.INVALID_LOGIN' }))
        })
    },
  })

  return (
    <>
      <form
        className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'
        noValidate
        id='kt_login_password_reset_form'
        onSubmit={formik.handleSubmit}
      >
        <div className='text-center mb-10'>
          {/* begin::Title */}
          <h1 className='text-dark mb-3'>{intl.formatMessage({ id: 'AUTH.FORGOT.TITLE' })}</h1>
          {/* end::Title */}

          {/* begin::Link */}
          <div className='text-gray-400 fw-bold fs-4'>{intl.formatMessage({ id: 'AUTH.FORGOT.DESC' })}.</div>
          {/* end::Link */}
        </div>

        {/* begin::Title */}
        {hasErrors === true && (
          <div className='mb-lg-15 alert alert-danger'>
            <div className='alert-text font-weight-bold'>{responseString}</div>
          </div>
        )}

        {hasErrors === false && (
          <div className='mb-10 bg-light-info p-8 rounded'>
            <div className='text-info'>{responseString}</div>
          </div>
        )}
        {/* end::Title */}

        {hasErrors !== false && (
          <>
            {/* begin::Form group */}
            <div className='fv-row mb-10'>
              <label className='form-label fw-bolder text-gray-900 fs-6'>{intl.formatMessage({ id: 'AUTH.INPUT.EMAIL' })}</label>
              <input
                type='email'
                placeholder='youremail@example.com'
                autoComplete='off'
                {...formik.getFieldProps('email')}
                className={clsx(
                  'form-control form-control-lg form-control-solid',
                  { 'is-invalid': formik.touched.email && formik.errors.email },
                  {
                    'is-valid': formik.touched.email && !formik.errors.email,
                  }
                )}
              />
              {formik.touched.email && formik.errors.email && (
                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block'>
                    <span className='text text-danger' role='alert'>{formik.errors.email}</span>
                  </div>
                </div>
              )}
            </div>
            {/* end::Form group */}

            {/* begin::Form group */}
            <div className='d-flex flex-wrap justify-content-center pb-lg-0'>
              <button
                type='submit'
                id='kt_password_reset_submit'
                className='btn btn-lg btn-primary fw-bolder me-4'
              >
                {!loading && <span className='indicator-label'>{intl.formatMessage({ id: 'AUTH.CONTINUE.BUTTON' })}</span>}
                {loading && (
                  <span className='indicator-progress' style={{ display: 'block' }}>
                    {intl.formatMessage({ id: 'AUTH.GENERAL.PLEASE_WAIT' })}
                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                  </span>
                )}
              </button>
              <Link to='/auth/login' reloadDocument>
                <button
                  type='button'
                  id='kt_login_password_reset_form_cancel_button'
                  className='btn btn-lg btn-light-primary fw-bolder'
                  disabled={formik.isSubmitting || !formik.isValid}
                >
                  {intl.formatMessage({ id: 'BUTTON.CANCEL' })}
                </button>
              </Link>{' '}
            </div>
            {/* end::Form group */}
          </>
        )}
      </form>
    </>
  )
}
